import React from 'react'

export const routerRef = React.createRef()

export const routerPush = (route = '') => {
	routerRef.current.history.push(route)
}
